<template>
  <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" @click="goToHome">
        <span style="color:red;font-weight:bold;">DetectX</span>
      </a>

      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasic">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarBasic" class="navbar-menu">
      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            Product
          </a>

          <div class="navbar-dropdown">
            <a class="navbar-item" href="#aboutdetectx">
              About DetectX
            </a>
            <a class="navbar-item" href="#howdoesdetectxwork">
              How does DetectX work?
            </a>
          </div>
        </div>

        <a class="navbar-item" href="#mllab">
          DetectX Lab
        </a>
        <a class="navbar-item" href="#price">
          Price
        </a>
        <a class="navbar-item" href="#about">
          About
        </a>
        <div class="navbar-item">
          <img :src="profileIcon" />
        </div>
        <div class="navbar-item" v-show="!profileIcon" @click="login">
          <div class="buttons">
            <a class="button is-primary">
              <strong>Sign In</strong>
            </a>
          </div>
        </div>
        <div class="navbar-item" v-show="profileIcon" @click="signOut">
          <div class="buttons">
            <a class="button">
              <strong>Sign Out</strong>
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import helper from '@/helper'

export default {
  computed: {
    profileIcon() {
      return helper.profileIcon()
    }
  },
  methods: {
    goToHome() {
      this.$router.push('/')
    },
    login() {
      return helper.firestoreLogin()
    },
    signOut() {
      return helper.firestoreSignOut()
    }
  }
}
</script>
